import React from "react";
import FAQ from "../component/FAQ";
import backgroundImageUrl from "../assets/aboutimg/7250.jpg"
import bgt from "../assets/aboutimg/bgt.png"

const About = () => {
    // const backgroundImageUrl = 'https://demo.cmssuperheroes.com/themeforest/finanzia/wp-content/uploads/ptitle-about.webp';

    return (
        <div
            data-elementor-type="wp-page"
            data-elementor-id="185"
            className="elementor elementor-185 elementor-18 elementor-8"
        >
            <div
                className="qodef-page-title qodef-m qodef-title--breadcrumbs qodef-alignment--left qodef-vertical-alignment--header-bottom"
                style={{
                    backgroundImage: `linear-gradient(to top, rgba(30, 73, 125, 100%), rgba(96,96,96, 0)),url(${backgroundImageUrl})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    position: 'relative',
                }}
            >



                <div className="qodef-m-content qodef-content-grid" style={{ width: '100%', textAlign: 'left', padding: '0 20px' }}>
                    {/* Breadcrumb Navigation */}
                    <div itemProp="breadcrumb" className="qodef-breadcrumbs" style={{ color: "#fff", margin: "11px 88px -226px 34px" }}>
                        <a itemProp="url" className="qodef-breadcrumbs-link" href="/" style={{ color: "#fff", textDecoration: "none" }}>
                            <span itemProp="title">Home</span>
                        </a>
                        {/* <span className="qodef-breadcrumbs-separator" style={{ margin: "0 10px", color: "#fff" }}> &gt; </span> */}
                        {/* <a itemProp="url" className="qodef-breadcrumbs-link" href="/server" style={{ color: "#fff", textDecoration: "none" }}>
                <span itemProp="title">Server</span>
            </a> */}
                        <span className="qodef-breadcrumbs-separator" style={{ margin: "0 10px", color: "#fff" }}> </span>
                        <span itemProp="title" className="qodef-breadcrumbs-current" style={{ color: "#fff" }}>
                            About Us
                        </span>
                    </div>
                </div>
            </div>
            {/* <div className="qodef-page-title qodef-m qodef-title--standard qodef-alignment--left qodef-vertical-alignment--header-bottom qodef--has-image" style={{
                backgroundImage: `url(${backgroundImageUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
            }}>
                <div className="qodef-m-inner">
                    <div className="qodef-m-content qodef-content-grid ">
                        <h1 className="qodef-m-title entry-title">About Us </h1>
                    </div>
                </div>
            </div> */}

            <div
                className="elementor-element elementor-element-3b1c742 e-con-full qodef-elementor-content-grid e-flex e-con e-parent new-css"
                data-id="3b1c742"
                data-element_type="container"
                style={{ margin: "100px 16px" }}
            >
                <div
                    className="elementor-element elementor-element-5386d30 e-con-full e-flex e-con e-child"
                    data-id="5386d30"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-ad3d20d elementor-widget elementor-widget-startpro_core_section_title"
                        data-id="ad3d20d"
                        data-element_type="widget"
                        data-widget_type="startpro_core_section_title.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                                <p style={{ fontSize: "16px", marginBottom: "10px" }} data-aos="fade-right"
                                    data-aos-offset="200" data-aos-delay="50" data-aos-duration="800">About Us</p>
                                <h2 className="qodef-m-title" data-aos="fade-right"
                                    data-aos-offset="200" data-aos-delay="50" data-aos-duration="900">
                                    Strategic Advisory<br /> & Project Management
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-645a6e1 e-con-full e-flex e-con e-child"
                    data-id="645a6e1"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-a40582d e-con-full e-flex e-con e-child"
                        data-id="a40582d"
                        data-element_type="container"
                        style={{ "--padding-bottom": "0px" }}
                    >
                        <p data-aos="fade-left"
                            data-aos-offset="200" data-aos-delay="50" data-aos-duration="900">
                            PMC Oman is a professional project management
                            consultancy <br />and a sister company of Engineering
                            Innovation Design & Consulting LLC (EIDC), a leading
                            engineering consultancy firm in Muscat, Oman. Operating
                            under the umbrella of  <span style={{ fontWeight: "500", color: "#1E497C" }}>Dr. Rashid Al Balushi </span> Design &
                            Consultancy, PMC Oman specializes in delivering
                            structured, data-driven solutions across various industries.

                        </p>

                    </div>
                    <div
                        className="elementor-element elementor-element-db50601 e-con-full e-flex e-con e-child"
                        data-id="db50601"
                        data-element_type="container"
                    >
                        <p data-aos="fade-left"
                            data-aos-offset="200" data-aos-delay="50" data-aos-duration="900" style={{ paddingTop: "20px" }}>
                            Our expertise spans the entire project lifecycle,
                            applying systematic management controls from precontract planning to post-contract execution and
                            turnover. By integrating advanced methodologies with
                            practical industry experience, PMC Oman ensures
                            seamless project delivery and sustainable success.

                        </p>
                    </div>
                </div>
            </div>

            <div
                className="elementor-element elementor-element-554e4d9 e-flex e-con-boxed e-con e-parent e-lazyloaded" style={{ marginBottom: "0", background: "#f5f5f5f5" }}
                data-element_type="container"
            >
                <div className="e-con-inner" >
                    <div
                        className="elementor-element elementor-element-60aabc8 e-con-full e-flex e-con e-child"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-c2bc88e e-con-full e-flex e-con e-child"
                            data-id="c2bc88e"
                            data-element_type="container"
                        >
                            <div
                                className="elementor-element elementor-element-198b616 elementor-widget__width-inherit elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading"
                                data-id="198b616"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                            >
                                <p style={{ fontSize: "16px", fontFamily: "Poppins", fontWeight: "400", marginBottom: "10px" }} data-aos="fade-right"
                                    data-aos-offset="400" data-aos-delay="100" data-aos-duration="800">Our Mission</p>
                                <h2 className="elementor-heading-title elementor-size-default" data-aos="fade-right"
                                    data-aos-offset="200" data-aos-delay="50" data-aos-duration="900">
                                    Delivering Quality
                                    <br />   with Precision

                                </h2>{" "}
                            </div>
                            <div
                                className="elementor-element elementor-element-f7dfb16 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor"
                                data-id="f7dfb16"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                            >
                                <header
                                    className="bt_bb_headline bt_bb_color_scheme_5 bt_bb_dash_none bt_bb_superheadline bt_bb_subheadline bt_bb_size_medium bt_bb_align_inherit"
                                    data-bt-override-class="{}"
                                >
                                    <div className="bt_bb_headline_subheadline" style={{ paddingRight: "38px" }} data-aos="fade-right"
                                        data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                                        We are committed to delivering the highest quality<br /> services
                                        through meticulous planning and execution. By providing tailored
                                        solutions, we ensure that every project exceeds expectations while
                                        fostering a team of <br />industry-leading professionals.




                                    </div>
                                </header>{" "}
                            </div>
                        </div>
                        <div className="elementor-element elementor-element-1ece496 e-con-full e-flex e-con e-child" data-id="1ece496" data-element_type="container" data-settings="{&quot;_ha_eqh_enable&quot;:false}" data-aos="fade-left"
                            data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                            <div className="elementor-element elementor-element-165aa78 elementor-widget elementor-widget-image" data-id="165aa78" data-element_type="widget" data-widget_type="image.default" data-aos="fade-left"
                                data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                                <img loading="lazy" decoding="async" width="800" height="534" src="/img/9305.jpg" className="attachment-large size-large wp-image-1827" alt="" style={{ marginLeft: "-11px" }}

                                    //  srcset="https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-1024x683.webp 1024w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-300x200.webp 300w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-768x512.webp 768w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-1536x1024.webp 1536w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are.webp 1920w"
                                    sizes="(max-width: 800px) 100vw, 800px" />															</div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-60aabc8 e-con-full e-flex e-con e-child"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-a150873 e-con-full elementor-hidden-mobile e-flex e-con e-child"
                            data-id="c2bc88e"
                            data-element_type="container"
                            data-aos="fade-right"
                            data-aos-offset="200" data-aos-delay="100" data-aos-duration="900"
                        >
                            <div className="elementor-element elementor-element-165aa78 elementor-widget elementor-widget-image" data-id="165aa78" data-element_type="widget" data-widget_type="image.default">
                                <img loading="lazy" decoding="async" width="800" height="534" src="/img/19914.jpg" className="attachment-large size-large wp-image-1827" alt="" style={{ width: "570px", height: "380px", objectFit: "cover" }}
                                    // srcset="https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-1024x683.webp 1024w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-300x200.webp 300w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-768x512.webp 768w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are-1536x1024.webp 1536w, https://quwalegal.com/wp-content/uploads/2024/10/who-we-are.webp 1920w"
                                    sizes="(max-width: 800px) 100vw, 800px" />															</div>

                        </div>
                        <div className="elementor-element elementor-element-d48b4fd e-con-full e-flex e-con e-child" data-id="1ece496" data-element_type="container" data-settings="{&quot;_ha_eqh_enable&quot;:false}">
                            <div
                                className="elementor-element elementor-element-198b616 elementor-widget__width-inherit elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading"
                                data-id="198b616"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                            >
                                <p style={{ fontSize: "16px", fontFamily: "Poppins", fontWeight: "400", marginBottom: "10px" }} data-aos="fade-left"
                                    data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">Our Vision</p>
                                <h2 className="elementor-heading-title elementor-size-default" data-aos="fade-left"
                                    data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                                    Leading the Way in
                                    <br />Project Management
                                </h2>{" "}
                            </div>
                            <div
                                className="elementor-element elementor-element-f7dfb16 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor"
                                data-id="f7dfb16"
                                data-element_type="widget"
                                data-widget_type="text-editor.default"
                            >
                                <header
                                    className="bt_bb_headline bt_bb_color_scheme_5 bt_bb_dash_none bt_bb_superheadline bt_bb_subheadline bt_bb_size_medium bt_bb_align_inherit"
                                    data-bt-override-class="{}"
                                >
                                    <div className="bt_bb_headline_subheadline" data-aos="fade-left"
                                        data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                                        To be the trusted partner for organizations in the region,
                                        <br/>delivering excellence in project management, management
                                        consultancy, and financial advisory services. We aim to empower our
                                        clients to achieve sustainable growth, and financial resilience through
                                        tailored strategies and unwavering commitment<br/> to quality.
                                    </div>
                                </header>{" "}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="elementor-element elementor-element-3273da6 pt-110 pb-15 p-tb-tablet-40 e-flex e-con-boxed e-con e-parent e-lazyloaded">
                <div className="e-con-inner">
                    <div
                        className="elementor-element elementor-element-cb68fda elementor-widget__width-initial pb-40 elementor-widget elementor-widget-cms_heading cms-inview animated undefined fadeInUp"
                        data-id="cb68fda"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="cms_heading.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="cms-eheading cms-eheading-1 text-center">
                                <div className="cms-smallheading text-18  pb-15 mt-n7 empty-none">
                                    The Foundation of Our Work
                                </div>
                                <h2 className="cms-heading empty-none text-heading m-tb-n10">
                                    Our values define our approach and strengthen our partnerships
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-c0b4367 elementor-widget elementor-widget-cms_fancy_box cms-inview animated fadeInUp undefined"
                        data-id="c0b4367"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="cms_fancy_box.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="cms-fancyboxs-4 d-flex gutter flex-col-4 flex-col-tablet-3 flex-col-mobile-extra-2 flex-col-mobile-2 flex-col-smobile-1 text-start">
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                01.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Integrity
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    We uphold the <br />highest ethical standards in all<br /> our planning &
                                                    <br />engagements.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                02.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Excellence{" "}
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    We are committed <br />to delivering superior solutions with
                                                    precision and expertise.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                03.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Innovation
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    We embrace<br />cutting-edge strategies and technologies to
                                                    drive success.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                04.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Collaboration
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    We believe in <br />fostering strong partnerships with
                                                    clients and stakeholders.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                05.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Sustainability{" "}
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    We integrate responsible practices that contribute to
                                                    long-term resilience.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                06.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Teamwork
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>Fostering collaboration to achieve shared goals.<br /><br /></p>

                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="fancy-box-item relative">
                                    <div className="cms-fancybox relative overflow-hidden cms-fancybox-4 hover-icon-bounce bdr-t-1 bdr-l-1 bdr-divider bdr-hover-transparent cms-hover-change p-tb-40 pl-40 pr-30">
                                        <div className="bg-gradient-1 cms-transition cms-overlay cms-hover-show always move-left"></div>
                                        <div className="relative z-top">
                                            <div
                                                className="count text-on-hover-white pb cms-transition"
                                                style={{ "--pb": "65px" }}
                                            >
                                                07.
                                            </div>
                                            <div className="cms-title cms-heading cms-nl2br cms-transition  text-on-hover-white text-19 mt-n5 pb-10">
                                                Respect & Trust{" "}
                                            </div>
                                            <div className="cms-desc cms-nl2br cms-transition  text-on-hover-primary-lighten text-15 mb-n5 empty-none">
                                                <p>
                                                    Building strong, <br />lasting relationships with clients
                                                    and stakeholders.
                                                </p>
                                            </div>
                                            <a
                                                className="mt box-47 circle bdr-1 bdr-accent bdr-on-hover-white bg-on-hover-white text-accent cms-hover-icon-zoomout"
                                                style={{ "--mt": "70px", visibility: "hidden" }}
                                            >
                                                <span className="screen-reader-text">Explore More</span>
                                                <span className="cms-svg-icon lh-0 text-12 rtl-flip empty-none">
                                                    <svg
                                                        viewBox="0 0 13 13"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {" "}
                                                        <path d="M5.9 11.9C5.9 12.2314 6.16863 12.5 6.5 12.5C6.83137 12.5 7.1 12.2314 7.1 11.9V7.1H11.9C12.2314 7.1 12.5 6.83137 12.5 6.5C12.5 6.16863 12.2314 5.9 11.9 5.9H7.1V1.1C7.1 0.768629 6.83137 0.5 6.5 0.5C6.16863 0.5 5.9 0.768629 5.9 1.1V5.9H1.1C0.768629 5.9 0.5 6.16863 0.5 6.5C0.5 6.83137 0.768629 7.1 1.1 7.1H5.9V11.9Z"></path>{" "}
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-3b1c742 e-con-full qodef-elementor-content-grid e-flex e-con e-parent pad-0 bg-image"
                data-id="3b1c742"
                data-element_type="container"
                style={{ "--flex-direction": "column", }}
            >
                <h2 className="qodef-m-title" style={{ textAlign: "center" }} data-aos="fade-right"
                    data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                    Message from the
                    <br />  Founder & CEO
                </h2>
                <div className="qodef-m-content-1" data-aos="fade-right"
                    data-aos-offset="200" data-aos-delay="100" data-aos-duration="900">
                    <p style={{ fontSize: "16px", textAlign: "justify" }}>At <span style={{ fontWeight: "600" }}>PMC Oman,</span> we believe that success is built on a foundation of vision, strategy, and unwavering commitment. When I founded this company, my goal was simple yet ambitious: to create a consultancy that not only delivers world-class project management but also drives transformation and innovation in every endeavor.
                        Every project we undertake is more than just a contract—it is an opportunity to shape the future, to build legacies, and to create lasting value for our clients and communities. Our team’s expertise, coupled with our relentless pursuit of excellence, allows us to navigate complexities, mitigate risks, and deliver results that exceed expectations.</p>
                    <p style={{ fontSize: "16px", textAlign: "justify" }}>But beyond expertise and execution, what truly sets us apart is our <span style={{ fontWeight: "600" }}>commitment to people</span>—our clients, partners, and employees. We understand that behind every great achievement are strong relationships built on trust, transparency, and shared goals. It is this philosophy that drives PMC Oman forward, empowering businesses, industries, and economies.</p>
                    <p style={{ fontSize: "16px", textAlign: "justify" }}>As we continue to grow and evolve, our focus remains steadfast: to<span style={{ fontWeight: "600" }}> lead with integrity, to innovate fearlessly, and to transform challenges into opportunities.</span> Together, we will redefine possibilities and build a smarter, stronger future.</p>
                    <p style={{ fontSize: "16px", textAlign: "justify", fontWeight: "600" }}>Thank you for being a part of our journey.</p>
                </div>
                <img src="/img/PMC-COMPANY.png" alt="Founder & CEO" className="qodef-m-content-img" />
            </div>
            <FAQ />
        </div>
    );
};

export default About;
